import React, { useState } from "react";
import { sidebar } from "../data/Data";
import { products, more_products } from "../data/Data";
import Video from "./Video";

export default function Sidebar(props) {
  const { onFilterChange, showFilters, onToggleFilters, visibleProducts } = props;

  /**
   * Filter counts used to come from hardcoded strings in Data.js and were badly
   * wrong: "Rose (30)" against a single rose product, "Lavender (11)" against
   * one, and a "Pineapple" row that matched nothing in the catalogue at all.
   *
   * Now counted live from the same list the grid renders, using the same
   * substring match the filter itself applies (see nameCheck in Shop.js), so
   * the number on a label is the number of cards you actually get. Rows that
   * match nothing are dropped rather than advertised.
   */
  // Shop.js passes its season-filtered catalogue, not the currently-filtered
  // list, so counts stay stable as you tick boxes rather than collapsing to 1.
  const catalogue =
    visibleProducts && visibleProducts.length
      ? visibleProducts
      : [...products, ...more_products];

  const countFor = (variety) =>
    catalogue.filter((item) =>
      item.product_name?.toLowerCase().includes(variety.toLowerCase())
    ).length;
  const [expandedSections, setExpandedSections] = useState({
    0: true, // Expand first section by default
    1: true, // Expand second section by default
    2: true  // Expand third section by default
  });

  const filterItems = (evt, filter, typeIndex) => {
    onFilterChange(evt, filter, typeIndex);
  };

  const toggleSection = (index) => {
    setExpandedSections(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const getCategoryIcon = (header) => {
    const iconMap = {
      'Fragrance': 'fas fa-leaf',
      'Category': 'fas fa-tags',
      'Price': 'fas fa-rupee-sign',
      'Brand': 'fas fa-star',
      'Size': 'fas fa-ruler'
    };
    return iconMap[header] || 'fas fa-filter';
  };

  return (
    <>
      <div className={`col-lg-3 col-md-4 ${showFilters ? 'filters-visible' : 'filters-hidden'}`}>
        <div className="modern-sidebar">
          {/* Sidebar Header */}
          <div className="sidebar-header d-lg-none">
            <h4>
              <i className="fas fa-filter mr-2"></i>
              Filters
            </h4>
            <button 
              className="close-filters"
              onClick={onToggleFilters}
              title="Close Filters"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Filter Sections */}
          {sidebar.map((val, index) => {
            const rows = val.subItem
              .map((item) => ({ ...item, matches: countFor(item.variety) }))
              .filter((item) => item.matches > 0);

            // A section with nothing behind it is just noise.
            if (!rows.length) return null;

            return (
            <div key={index} className="filter-section">
              <div 
                className="filter-section-header"
                onClick={() => toggleSection(index)}
              >
                <div className="section-title-wrapper">
                  <i className={`${getCategoryIcon(val.header)} section-icon`}></i>
                  <h6 className="section-title">{val.header}</h6>
                </div>
                <i className={`fas fa-chevron-${expandedSections[index] ? 'up' : 'down'} toggle-icon`}></i>
              </div>
              
              <div className={`filter-section-content ${expandedSections[index] !== false ? 'expanded' : 'collapsed'}`}>
                <form>
                  {rows.map((item, itemIndex) => (
                    <div
                      className="modern-filter-item"
                      key={itemIndex}
                    >
                      <div className="filter-checkbox-wrapper">
                        <input
                          type="checkbox"
                          className="modern-checkbox"
                          id={`filter-${index}-${itemIndex}`}
                          onChange={(evt) => filterItems(evt, item, val)}
                        />
                        <label 
                          className="modern-checkbox-label"
                          htmlFor={`filter-${index}-${itemIndex}`}
                        >
                          <span className="checkbox-custom"></span>
                          <span className="filter-name">{item.variety}</span>
                        </label>
                      </div>
                      <span className="filter-count">
                        {item.matches}
                      </span>
                    </div>
                  ))}
                </form>
              </div>
            </div>
            );
          })}

          {/* Featured Video Section */}
          <div className="featured-video-section">
            <div className="video-header">
              <i className="fas fa-play-circle video-icon"></i>
              <h6 className="video-title">Featured Video</h6>
            </div>
            <div className="video-container">
              <Video url="../../assets/nt/ntvideo2.mp4" poster="../../assets/nt/1.jpg" width="100%" height="100%"/>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="quick-actions">
            <button className="action-btn primary">
              <i className="fas fa-heart mr-2"></i>
              View Wishlist
            </button>
            <button className="action-btn secondary">
              <i className="fas fa-phone mr-2"></i>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
